import { createSelector } from 'reselect';

export const authByFacebookStateSelector = state => state.auth.authByFacebook;

export const authByFacebookSigningSelector = createSelector(
  authByFacebookStateSelector,
  s => s.isSigning
);

export const authByFacebookErrorSelector = createSelector(
  authByFacebookStateSelector,
  s => s.signError
)